var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contnet"},[(_vm.show_page)?_c('div',[_c('p',[_vm._v("微信授权")]),_c('p',{staticClass:"authBtn",on:{"click":_vm.clickAuth}},[_vm._v("点击授权")]),_c('p',{staticClass:"authBtn",on:{"click":_vm.clickShare}},[_vm._v("点击配置分享")])]):_c('div',[_c('p',{staticClass:"tips"},[_vm._v("请使用微信浏览器打开")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }